import http from "@/utils/request"
import config from "@/config"

// 开发配置管理（/develop/classify 配置分类 + /develop/developdata 数据组）
// app 参数：''=平台配置(common) / 'bwmall'=商城配置(member)
export default {
	tabList: {
		url: `${config.API_URL}/manage/develop/config/tabList`,
		name: "配置分类列表",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		}
	},
	tabOptions: {
		url: `${config.API_URL}/manage/develop/config/tabOptions`,
		name: "配置分类下拉",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		}
	},
	tabSave: {
		url: `${config.API_URL}/manage/develop/config/tabSave`,
		name: "配置分类保存",
		post: async function (data = {}) {
			return await http.post(this.url, data);
		}
	},
	tabDelete: {
		url: `${config.API_URL}/manage/develop/config/tabDelete`,
		name: "配置分类删除",
		post: async function (data = {}) {
			return await http.post(this.url, data);
		}
	},
	tabShow: {
		url: `${config.API_URL}/manage/develop/config/tabShow`,
		name: "配置分类显示开关",
		post: async function (data = {}) {
			return await http.post(this.url, data);
		}
	},
	configList: {
		url: `${config.API_URL}/manage/develop/config/configList`,
		name: "配置项列表",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		}
	},
	configSave: {
		url: `${config.API_URL}/manage/develop/config/configSave`,
		name: "配置项保存",
		post: async function (data = {}) {
			return await http.post(this.url, data);
		}
	},
	configDelete: {
		url: `${config.API_URL}/manage/develop/config/configDelete`,
		name: "配置项删除",
		post: async function (data = {}) {
			return await http.post(this.url, data);
		}
	},
	configShow: {
		url: `${config.API_URL}/manage/develop/config/configShow`,
		name: "配置项显示开关",
		post: async function (data = {}) {
			return await http.post(this.url, data);
		}
	},
	groupList: {
		url: `${config.API_URL}/manage/develop/group/groupList`,
		name: "数据组列表",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		}
	},
	groupSave: {
		url: `${config.API_URL}/manage/develop/group/groupSave`,
		name: "数据组保存",
		post: async function (data = {}) {
			return await http.post(this.url, data);
		}
	},
	groupDelete: {
		url: `${config.API_URL}/manage/develop/group/groupDelete`,
		name: "数据组删除",
		post: async function (data = {}) {
			return await http.post(this.url, data);
		}
	},
	groupFormData: {
		url: `${config.API_URL}/manage/develop/group/groupFormData`,
		name: "数据组动态表单定义",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		}
	},
}
